export const rewardTypeList = [
  { value: 1, label: '金币', other: '金币数量', typeId: '0' },
  { value: 2, label: '礼物', other: '礼物数量', typeId: '礼物配置 礼物Id' },
  { value: 3, label: '通话卡', other: '通话卡数量', typeId: '0' },
  { value: 4, label: 'VIP', other: 'VIP天数', typeId: '0' },
  { value: 6, label: '贵族天数', other: '贵族天数', typeId: '1~6' },
  { value: 7, label: '等级积分', other: '积分数量', typeId: '3用户等级 4主播等级' },
  { value: 8, label: '勋章', other: '勋章天数', typeId: '勋章配置管理 勋章id' },
  { value: 9, label: '钻石', other: '钻石数量', typeId: '0' },
  { value: 10, label: '礼物钻石', other: '礼物数量', typeId: '礼物配置 礼物Id' },
  { value: 11, label: '游戏货币', other: '游戏货币数量', typeId: '0' },
  { value: 12, label: '用户任务积分', other: '积分分数', typeId: '0' },
  { value: 1001, label: '头像框', other: '天数', typeId: '房间物品配置 装扮ID' },
  { value: 1002, label: '气泡框', other: '天数', typeId: '房间物品配置 装扮ID' },
  { value: 1003, label: '座驾', other: '天数', typeId: '房间物品配置 装扮ID' },
  { value: 1004, label: '进场特效', other: '天数', typeId: '房间物品配置 装扮ID' },
  { value: 1008, label: '称号', other: '天数', typeId: '房间物品配置 装扮ID' },
  { value: 1009, label: '主播标签', other: '标签', typeId: '1推荐标签 2新主播标签' },
  { value: 1010, label: '资料卡披肩', other: '天数', typeId: '房间物品配置 装扮ID' },
  { value: 2001, label: '星动嘉年华抽奖券', other: '数量', typeId: '1初级抽奖券 2中级抽奖券' },
  { value: 9999, label: '活动货币', other: '数量', typeId: '活动货币组件id' },
  { value: 10000, label: '其他物品', other: '自定义', typeId: '自定义' }
]